@switch (innslag().type()) {
  @case (innslagTyper.ingenTidligere) {
    <div class="ingen-flere">
      {{ 'Ingen tidligere møter'|translate }}
    </div>
  }
  @case (innslagTyper.stedfortrederFoer) {
    <div class="stedfortreder" @fadeInnUt>
      <ng-container *ngTemplateOutlet="stedfortrederFragment"/>
    </div>
  }
  @case (innslagTyper.moete) {
    <!-- matTooltipShowDelay=1sekund slik at tooltip ikke vises før animert ekspandering ved mus-over i smal visning har animert høydeendringen ferdig -->
    <div class="møte" [matTooltip]="moeteTooltip()" [matTooltipShowDelay]="1000" data-testid="møte" @fadeInnUt>
      <div class="dato-og-tid" data-testid="datoOgTid">
        <span>{{ moetedato | async }}</span>
        <span>{{ moete()!.moete.dato.start | zoneddatetimeSomPlainTime | plaintime }}</span>
      </div>
      <div class="tittel-og-nummer" data-testid="tittelOgNummer">
        <span class="tittel" data-testid="navn">{{ moete()!.moete.tittel }}</span>
        <span data-testid="nummer">{{ moete()!.moete.nummer }}</span>
      </div>
      <div class="detaljer">
        <span class="ansvar">
          @if (moete()!.agregater.antallSakerMine > 0) {
            {{ 'Ansvar for {antall} saker'|translate: {antall: moete()!.agregater.antallSakerMine} }}
          }
        </span>
        <span class="tellere">
          @if (moete()!.agregater.antallUlesteDokumenter > 0) {
            <ikon-med-teller [teller]="moete()!.agregater.antallUlesteDokumenter" fontSet="lederplan-ikon-dokument" class="mat-icon--lederplan-ikon"
                             matTooltip="{{'Antall uleste dokumenter'|translate}}" matTooltipPositionAtOrigin="true"/>
          }
          @if (moete()!.agregater.antallOppgaverForfalt > 0) {
            <ikon-med-teller [teller]="moete()!.agregater.antallOppgaverForfalt" fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon"
                             matTooltip="{{'Antall forfalte oppgaver'|translate}}" matTooltipPositionAtOrigin="true"/>
          }
        </span>
      </div>
    </div>
  }
  @case (innslagTyper.stedfortrederEtter) {
    <div class="stedfortreder" @fadeInnUt>
      <ng-container *ngTemplateOutlet="stedfortrederFragment"/>
    </div>
  }
  @case (innslagTyper.ingenSenere) {
    <div class="ingen-flere">
      {{ 'Ingen senere møter'|translate }}
    </div>
  }
}

@if (aktiv()) {
  <mat-icon class="aktiv-markering">arrow_drop_up</mat-icon>
}

<ng-template #stedfortrederFragment>
  <svg class="stedfortreder-grafikk" xmlns="http://www.w3.org/2000/svg" width="200" height="85" viewBox="0 0 200 85">
    <path d="m17.93,16.6c0,4.69,3.81,8.5,8.5,8.5h75.31c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5H26.43c-4.69,0-8.5,3.81-8.5,8.5,0,0,0-4.69,0,0Z"/>
    <path d="m142.68,16.6c0,4.69,3.81,8.5,8.5,8.5h21.76c4.69,0,8.5-3.81,8.5-8.5s-3.81-8.5-8.5-8.5h-21.76c-4.69,0-8.5,3.81-8.5,8.5,0,0,0-4.69,0,0Z"/>
    <path d="m17.93,40.07c0,3.54,2.87,6.4,6.4,6.4h96.49c3.54,0,6.4-2.87,6.4-6.4s-2.87-6.4-6.4-6.4H24.33c-3.54,0-6.4,2.87-6.4,6.4,0,0,0-3.54,0,0Z"/>
    <path d="m17.93,59.85c0,3.54,2.87,6.4,6.4,6.4h96.49c3.54,0,6.4-2.87,6.4-6.4s-2.87-6.4-6.4-6.4H24.33c-3.54,0-6.4,2.87-6.4,6.4,0,0,0-3.54,0,0Z"/>
    <rect width="200" height="85" style="fill:none;"/>
  </svg>
</ng-template>
